import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import CustomTextField from "../custom/CustomTextField";
import { isBlank } from "../../utils/ValidationRules";
import CustomNumberField from "../custom/CustomNumberField";
import CustomDatePicker from "../custom/CustomDatePicker";
import CustomButton from "../custom/CustomButton";
import apiClient from "../../utils/apiClient";
import Swal from "../../utils/swal";
import { showSuccessToast, showErrorToast } from "../../utils/swalToast";

const InsertPengabdianModal = ({ open, onClose, onSuccess }) => {
  const [topik, setTopik] = useState("");
  const [sumberBiaya, setSumberBiaya] = useState("");
  const [mulaiPenelitian, setMulaiPenelitian] = useState("");
  const [budget, setBudget] = useState("");
  const [actual, setActual] = useState("");

  useEffect(() => {
    if (!open) return;
    setTopik("");
    setSumberBiaya("");
    setMulaiPenelitian("");
    setBudget("");
    setActual("");
  }, [open]);

  const submitAbmas = (event) => {
    event.preventDefault();
    Swal.fire({
      text: "Masukkan pengabdian baru ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, masukan",
      cancelButtonText: "Tidak, jangan masukkan",
      confirmButtonColor: "#003158",
      cancelButtonColor: "#A92027",
    }).then((result) => {
      if (result.isConfirmed) {
        apiClient
          .post("/abmas", {
            mulaiPenelitian: mulaiPenelitian,
            topik: topik,
            sumberBiaya: sumberBiaya,
            budget: budget,
            actual: actual,
          })
          .then((response) => {
            showSuccessToast(response.data.msg);
            onSuccess();
          })
          .catch((err) => {
            showErrorToast(err.response.data.msg);
          });
      }
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Tambah Pengabdian</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item md={12} xs={12}>
            <Typography>
              Mulai Penelitian<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomDatePicker
              value={mulaiPenelitian}
              onChange={(event) => setMulaiPenelitian(event)}
              format={"DD/MM/YYYY"}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography>
              Topik Penelitian<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              value={topik}
              rule={(value) => isBlank(value, "Topik Penelitian")}
              onChange={(event) => setTopik(event.target.value)}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography>
              Sumber Biaya<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              rule={(value) => isBlank(value, "Sumber Biaya")}
              value={sumberBiaya}
              onChange={(event) => setSumberBiaya(event.target.value)}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography>
              Budget<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomNumberField
              rule={(value) => isBlank(value, "Budget")}
              value={budget}
              onChange={(event) => setBudget(event.target.value)}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography>
              Actual Budget<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomNumberField
              value={actual}
              rule={(value) => isBlank(value, "Actual Budget")}
              onChange={(event) => setActual(event.target.value)}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            <CustomButton
              text="Submit"
              baseColor="#003158"
              hoverColor="#00213A"
              onClick={submitAbmas}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default InsertPengabdianModal;
